/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ateliere_Connect_Status_Events_ProcessedInputs */

const en_ateliere_connect_status_events_processed = /** @type {(inputs: Ateliere_Connect_Status_Events_ProcessedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} events processed...`)
};

const fr_ateliere_connect_status_events_processed = /** @type {(inputs: Ateliere_Connect_Status_Events_ProcessedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} événements traités...`)
};

const de_ateliere_connect_status_events_processed = /** @type {(inputs: Ateliere_Connect_Status_Events_ProcessedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}-Ereignisse verarbeitet...`)
};

const it_ateliere_connect_status_events_processed = /** @type {(inputs: Ateliere_Connect_Status_Events_ProcessedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} eventi elaborati...`)
};

const ru_ateliere_connect_status_events_processed = /** @type {(inputs: Ateliere_Connect_Status_Events_ProcessedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`События ${i?.count} обработаны...`)
};

const es_ateliere_connect_status_events_processed = /** @type {(inputs: Ateliere_Connect_Status_Events_ProcessedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} eventos procesados...`)
};

const zh_cn2_ateliere_connect_status_events_processed = /** @type {(inputs: Ateliere_Connect_Status_Events_ProcessedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 事件已处理...`)
};

const ja_ateliere_connect_status_events_processed = /** @type {(inputs: Ateliere_Connect_Status_Events_ProcessedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件のイベントが処理されました...`)
};

const hi_ateliere_connect_status_events_processed = /** @type {(inputs: Ateliere_Connect_Status_Events_ProcessedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} इवेंट्स प्रोसेस हो गए...`)
};

const pt_pt2_ateliere_connect_status_events_processed = /** @type {(inputs: Ateliere_Connect_Status_Events_ProcessedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eventos ${i?.count} processados...`)
};

/**
* | output |
* | --- |
* | "{count} events processed..." |
*
* @param {Ateliere_Connect_Status_Events_ProcessedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_events_processed = /** @type {((inputs: Ateliere_Connect_Status_Events_ProcessedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Events_ProcessedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_status_events_processed(inputs)
	if (locale === "de") return de_ateliere_connect_status_events_processed(inputs)
	if (locale === "it") return it_ateliere_connect_status_events_processed(inputs)
	if (locale === "ru") return ru_ateliere_connect_status_events_processed(inputs)
	if (locale === "es") return es_ateliere_connect_status_events_processed(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_status_events_processed(inputs)
	if (locale === "ja") return ja_ateliere_connect_status_events_processed(inputs)
	if (locale === "hi") return hi_ateliere_connect_status_events_processed(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_status_events_processed(inputs)
	return en_ateliere_connect_status_events_processed(inputs)
});